const TmpA002 = (page, section) => {
  // pull images data from the page
  const modifiedPage = {
    ...page
  };

  //   remove extra stuff from question
  delete modifiedPage.content.question.multi_select;
  delete modifiedPage.content.question.para_num;
  delete modifiedPage.content.question.pdf_page;

  //   remove extra stuff from content
  delete modifiedPage.content.link;
  delete modifiedPage.content.media_url;
  delete modifiedPage.content.reading_title_en;
  delete modifiedPage.content.reading_title_tl;
  delete modifiedPage.content.source_url;
  delete modifiedPage.content.sp_url;

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpA002;
